"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _redux = require("redux");

var RequestState = _interopRequireWildcard(require("ecosystem-marketplace-core/constants/RequestState"));

var ActionTypes = _interopRequireWildcard(require("../actions/ActionTypes"));

var RequestKey = _interopRequireWildcard(require("../constants/RequestKey"));

var _combineReducers;

var requestStateFactory = function requestStateFactory(pendingActionType, succeededActionType, failedActionType, resetActionType) {
  return function () {
    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : RequestState.UNINITIALIZED;
    var action = arguments.length > 1 ? arguments[1] : undefined;

    switch (action.type) {
      case pendingActionType:
        return RequestState.PENDING;

      case succeededActionType:
        return RequestState.SUCCEEDED;

      case failedActionType:
        return RequestState.FAILED;

      case resetActionType:
        return RequestState.UNINITIALIZED;

      default:
        return state;
    }
  };
};

var _default = (0, _redux.combineReducers)((_combineReducers = {}, (0, _defineProperty2.default)(_combineReducers, RequestKey.APP_INTEGRATIONS, requestStateFactory(ActionTypes.APP_INTEGRATIONS_REQUESTED, ActionTypes.APP_INTEGRATIONS_RECEIVED, ActionTypes.APP_INTEGRATIONS_FAILED)), (0, _defineProperty2.default)(_combineReducers, RequestKey.ADMINS, requestStateFactory(ActionTypes.ADMIN_FETCH_REQUESTED, ActionTypes.ADMIN_FETCH_RECEIVED, ActionTypes.ADMIN_FETCH_FAILED)), (0, _defineProperty2.default)(_combineReducers, RequestKey.HUBS, requestStateFactory(ActionTypes.HUB_FETCH_REQUESTED, ActionTypes.HUB_FETCH_RECEIVED, ActionTypes.HUB_FETCH_FAILED)), (0, _defineProperty2.default)(_combineReducers, RequestKey.REVIEW_WRITE, requestStateFactory(ActionTypes.REVIEW_WRITE_REQUESTED, ActionTypes.REVIEW_WRITE_RECEIVED, ActionTypes.REVIEW_WRITE_FAILED)), (0, _defineProperty2.default)(_combineReducers, RequestKey.REVIEWS_FETCH, requestStateFactory(ActionTypes.REVIEWS_FETCH_REQUESTED, ActionTypes.REVIEWS_FETCH_RECEIVED, ActionTypes.REVIEWS_FETCH_FAILED, ActionTypes.REVIEWS_FETCH_RESET)), (0, _defineProperty2.default)(_combineReducers, RequestKey.REVIEWS_STATS, requestStateFactory(ActionTypes.REVIEWS_STATS_REQUESTED, ActionTypes.REVIEWS_STATS_RECEIVED, ActionTypes.REVIEWS_STATS_FAILED, ActionTypes.REVIEWS_STATS_RESET)), (0, _defineProperty2.default)(_combineReducers, RequestKey.DETAILS_MORE_APPS_FETCH, requestStateFactory(ActionTypes.DETAILS_MORE_APPS_FETCH_REQUESTED, ActionTypes.DETAILS_MORE_APPS_FETCH_RECEIVED, ActionTypes.DETAILS_MORE_APPS_FETCH_FAILED, ActionTypes.DETAILS_MORE_APPS_RESET)), _combineReducers));

exports.default = _default;
module.exports = exports.default;


//////////////////
// WEBPACK FOOTER
// ./js/reducers/requestStates.js
// module id = 640
// module chunks = 209 210 211 212